import axios from "axios";
import { beginRequestActivity, usesFullPageLoader } from "./requestActivity";

const installed = new WeakSet();
const originals = new WeakMap();

/** Only explicitly blocking operations use the overlay; reads and forms stay local. */
export function installRequestLoader(client) {
  if (!client?.interceptors?.request || installed.has(client)) return client;
  installed.add(client);
  client.interceptors.request.use(config => {
    const selected = axios.getAdapter(config.adapter || client.defaults.adapter, config);
    const adapter = originals.get(selected) || selected;
    // Begin after serialization succeeds; always finish even when an adapter
    // throws an error without an Axios config, times out or is cancelled.
    config.adapter = async request => {
      if (!usesFullPageLoader(request) || request.signal?.aborted) return adapter(request);
      const finish = beginRequestActivity();
      const signal = request.signal;
      signal?.addEventListener("abort", finish, { once: true });
      try { return await adapter(request); }
      finally { signal?.removeEventListener("abort", finish); finish(); }
    };
    originals.set(config.adapter, adapter); // A retry of error.config must not nest trackers.
    return config;
  });
  return client;
}
